module.exports = __webpack_public_path__ + "img/help_3.8db4d588.png";